import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ProductKitNoNestingFragment,
  ProductLocationInventoryPricingNoNestingFragment,
  ProductNoNestingFragment,
  ProductOptionNoNestingFragment,
  SelectedOptionNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Product as ProductEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import ProductModel from "../../data/model/Product";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { PageQueryOptions, pageQuery } from "../page-query";

const productsQuery = gql`
${ProductNoNestingFragment}
${ProductLocationInventoryPricingNoNestingFragment}
${ProductOptionNoNestingFragment}
${SelectedOptionNoNestingFragment}
${ProductKitNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
query GetProducts(${listVariables}) {
    products(${listOptions}) {
        items {
           ...ProductNoNesting
           locationInventoryPricing {
              ...ProductLocationInventoryPricingNoNesting
           }
           options {
            ...ProductOptionNoNesting
           }
           selectedOptions {
            ...SelectedOptionNoNesting
           }
           productKit {
            ...ProductKitNoNesting
           }
           image {
            path
           }
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const productDefinition = new EntityResourceDefinition<
  ProductEntity,
  ProductModel
>({
  entity: "products",
  query: productsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity.name;
    newEntity.taxable = fetchedEntity.taxable;
    newEntity.description = fetchedEntity.description || null;
    newEntity.webDescription = fetchedEntity.webDescription || null;
    newEntity.supplierStockCode = fetchedEntity.supplierStockCode || null;
    newEntity.webPrice = fetchedEntity.webPrice || null;
    newEntity.priceLookup = fetchedEntity.priceLookup || null;
    newEntity.weight = fetchedEntity.weight || null;
    newEntity.UOM = fetchedEntity.UOM || null;
    newEntity.stockCode = fetchedEntity.stockCode || null;
    newEntity.stockNumber = fetchedEntity.stockNumber;
    newEntity.variantParentId = fetchedEntity.variantParentId || null;
    newEntity.locationInventoryPricing = fetchedEntity.locationInventoryPricing;
    newEntity.totalInventory = fetchedEntity.totalInventory;
    newEntity.hasVariants = fetchedEntity.hasVariants;
    newEntity.displayName = fetchedEntity.displayName;
    newEntity.totalVariants = fetchedEntity.totalVariants;
    newEntity.department.id = fetchedEntity.departmentId || null;
    newEntity.category.id = fetchedEntity.categoryId || null;
    newEntity.supplier.id = fetchedEntity.supplierId || null;
    newEntity.productKit.id = fetchedEntity.productKit?.id || null;
    newEntity.options = fetchedEntity.options;
    newEntity.selectedOptions = fetchedEntity.selectedOptions;
    newEntity.discountable = fetchedEntity.adjustable;
    newEntity.imageUrl = fetchedEntity.image?.path;
    newEntity.internal = fetchedEntity.internal;
    newEntity.active = fetchedEntity.active;
    newEntity.serialNumbersArr = fetchedEntity.serialNumbersArr;
    newEntity.serialNumbersSale = fetchedEntity.serialNumbersSale;
    newEntity.loyaltyPointEarnValue = fetchedEntity.loyaltyPointEarnValue;
    newEntity.loyaltyPointRedeemValue = fetchedEntity.loyaltyPointRedeemValue;
    newEntity.tags = fetchedEntity.tags ?? [];
    newEntity.adjustable = fetchedEntity.adjustable;
  },
  fetchEntities: (options?: PageQueryOptions) => {
    return pageQuery(client, "products", productsQuery, options);
  },
});
